<template>
  <div>
    <v-layout flat color="white">
      <div class="search-bar">
        <v-layout justify-begin align-center>
          <v-text-field
            @input="updateSearch($event)"
            :label="search_label"
            prepend-inner-icon="search"
            class="search-field"
            solo
            hide-details
          />
          <v-spacer></v-spacer>
          <companyContactForm
            v-if="button_type == 'contact_type_new_contact'"
            :contactType="contactType"
            newContact
          />
          <div v-if="button_display && !button_is_icon">
            <v-btn
              small
              depressed
              flat
              v-if="button_type == 'function'"
              class="primary white--text"
              @click="button_function()"
            >
              <v-icon small flat class="pr-2">{{ button_icon }}</v-icon>
              {{ button_label }}
            </v-btn>

            <v-btn
              small
              depressed
              flat
              v-if="button_type == 'link'"
              class="primary white--text"
              :to="button_parameter"
            >
              <v-icon small flat class="pr-2">{{ button_icon }}</v-icon>
              {{ button_label }}
            </v-btn>
          </div>

          <div v-if="button_display && button_is_icon">
            <v-tooltip left>
              <v-btn
                slot="activator"
                small
                depressed
                fab
                v-if="button_type == 'function'"
                class="theme_primary_lighten1 white--text"
                @click="button_function()"
              >
                <v-icon small flat>{{ button_icon }}</v-icon>
              </v-btn>
              <span>{{ button_label }}</span>
            </v-tooltip>

            <v-tooltip left>
              <v-btn
                slot="activator"
                small
                depressed
                fab
                v-if="button_type == 'link'"
                class="theme_primary_lighten1 white--text"
                :to="button_parameter"
              >
                <v-icon small flat>{{ button_icon }}</v-icon>
              </v-btn>
              <span>{{ button_label }}</span>
            </v-tooltip>
          </div>
        </v-layout>
      </div>
    </v-layout>
  </div>
</template>

<script>
import companyContactForm from "../companies/companyContactForm";
export default {
  name: "integratedSearchBar",
  components: {
    companyContactForm,
  },
  props: {
    contactType: {
      type: String,
      required: false,
    },
    search: {
      type: String,
      required: false,
      default: "",
    },
    search_label: {
      type: String,
      required: false,
      default: "Search...",
    },
    button_display: {
      type: Boolean,
      required: false,
      default: false,
    },
    button_type: {
      type: String,
      required: false,
      default: "emit_update",
    },
    button_label: {
      type: String,
      required: false,
      default: "",
    },
    button_icon: {
      type: String,
      required: false,
      default: "add",
    },
    button_parameter: {
      type: Object,
      required: false,
    },
    button_function: {
      type: Function,
      required: false,
    },
    button_is_icon: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  methods: {
    updateSearch(event) {
      this.$emit("update:search", event);
    },
  },
};
</script>

<style lang="stylus" scoped>
.search-bar {
  background-color: white;
  width: 100%;
   border-bottom: 0 !important;
}



.v-input__slot {
  margin-bottom: 0px !important;
}
</style>

<style>
.v-input__slot {
  margin-bottom: 0px !important;
  border-bottom: 0px !important;
}
</style>
